var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_1239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.48578 0.5 0 4.98578 0 10.5C0 16.0142 4.48578 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98578 15.5142 0.5 10 0.5ZM14.7559 15.6724C14.5934 15.8349 14.38 15.9167 14.1667 15.9167C13.9534 15.9167 13.7399 15.8349 13.5776 15.6724L9.41086 11.5059C9.25415 11.3501 9.16672 11.1383 9.16672 10.9167V5.5C9.16672 5.03918 9.53995 4.66672 10 4.66672C10.4601 4.66672 10.8333 5.03918 10.8333 5.5V10.5717L14.7559 14.4941C15.0816 14.8201 15.0816 15.3466 14.7559 15.6724Z",
    fill: "#5405D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_1239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.2320df5e.svg";
export { ForwardRef as ReactComponent };